import React, { useState, useEffect } from 'react';
import { Container, Form, Row, Col, Button, Card } from '@themesberg/react-bootstrap';
import { get, post } from '../../../services/back.service';
import useAutosave from '../../../hooks/useAutosave';

// Este formulario comparte endpoint con otros que escriben la cabecera; su
// scope propio evita que se bloqueen entre sí.
const SCOPE = 'header:result';

function FormFinalResult({ id }) {
  const [msgButton, setMsgButton] = useState('Guardar Informacion')
  const [dataFasecolda, setDataFasecolda] = useState([])
  const [infoResult, setInfoResult] = useState({
    insurable: "SI",
    fasecolda_code: '',
    fasecolda_value: 0,
    fasecolda_description: '',
    obs_inspection_result: '',
    reason_rejection: ''
  });

  const autosave = useAutosave(async () => {
    await post('/peritaje/modifyinspection/header/' + id, { ...infoResult, scope: SCOPE });
  });

  const sendInfo = async (event) => {
    event.preventDefault();
    autosave.cancel();
    const body = { ...infoResult, scope: SCOPE };
    const respo = await post('/peritaje/modifyinspection/header/' + id, body);
    if (respo.success) {
      setMsgButton('Actualizar')
    }
  };


  const handleForm = ({ target }) => {
    const value = target.type === 'checkbox' ? target.checked : target.value;
    setInfoResult({ ...infoResult, [target.name]: value });
    autosave.schedule();
    //generalUpdate(target.name, value);
  };

  const getOptionFasecolda = async () => {
    setDataFasecolda([])
    const respo = await get('/peritaje/fasecoldarefer/' + id, {});
    if (respo.success) {
      setDataFasecolda(respo.data)
    }
  }

  const selectInfoFasecolda = (data) => {
    const description = `${data.brand} - ${data.reference1} ${data.reference2} ${data.reference3}`;
    setInfoResult(prev => ({
      ...prev,
      fasecolda_code: data.code,
      fasecolda_value: data.price * 1000,
      fasecolda_description: description,
    }))
  }

  useEffect(() => {
    const initForm = async () => {
      const respo = await get('/peritaje/infoinspection/' + id, {});
      if (respo.success) {
        setInfoResult({
          insurable: respo.data.insurable,
          fasecolda_code: respo.data.fasecolda_code,
          fasecolda_value: respo.data.fasecolda_value,
          fasecolda_description: respo.data.fasecolda_description,
          obs_inspection_result: respo.data.obs_inspection_result,
          reason_rejection: respo.data.reason_rejection,
        });
      }
    };
    initForm();
  }, [id]);

  return (
    <Container>
      <Row className="mb-1">
        <Col>
          <h1 className="fw-bold">RESULTADO</h1>
        </Col>
        <Col>
          <Button onClick={getOptionFasecolda}>Consulta Fasecolda</Button>
        </Col>
      </Row>
      <Row className="mb-1">
        {dataFasecolda.map((element, i) => {
          const description = `${element.brand} - ${element.reference1} ${element.reference2} ${element.reference3}`;
          return (
            <Card onClick={() => selectInfoFasecolda(element)} className='mt-1 mr-1'>
              <Card.Body>{description}</Card.Body>
            </Card>
          )
        })}
      </Row>
      <hr style={{ opacity: 0.1 }} />
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="insurable">Asegurable</Form.Label>
          <Form.Select
            name="insurable"
            value={infoResult.insurable}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
            required
          >
            <option value="NO APLICA">NO APLICA</option>
            <option value="SI">SI</option>
            <option value="NO">NO</option>
            <option value="APROBADO">APROBADO</option>
            <option value="NO APROBADO">NO APROBADO</option>
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="fasecolda_code">Codigo Fasecolda</Form.Label>
          <Form.Control
            type="text"
            name="fasecolda_code"
            value={infoResult.fasecolda_code}
            onChange={(e) => handleForm(e)}
            required
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="fasecolda_value">Valor Fasecolda</Form.Label>
          <Form.Control
            type="number"
            name="fasecolda_value"
            value={infoResult.fasecolda_value}
            onChange={(e) => handleForm(e)}
            required
          />
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="fasecolda_description">Descripcion Fasecolda</Form.Label>
          <Form.Control
            type="text"
            name="fasecolda_description"
            value={infoResult.fasecolda_description}
            onChange={(e) => handleForm(e)}
            required
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Label htmlFor="obs_inspection_result">Observacion</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            name="obs_inspection_result"
            className="fw-bold text-uppercase"
            value={infoResult.obs_inspection_result}
            onChange={(e) => handleForm(e)}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Label htmlFor="reason_rejection">Causal de rechazo</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            name="reason_rejection"
            className="fw-bold text-uppercase"
            value={infoResult.reason_rejection}
            onChange={(e) => handleForm(e)}
          />
        </Col>
      </Row>
      <Row className="my-3">
        <Col className="d-flex justify-content-end">
          <Button type="button" variant="primary" onClick={sendInfo}>
            {msgButton}
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default FormFinalResult;
